import { ProjectCostCenterBase } from './base/project-cost-center-base';

export class ProjectCostCenter extends ProjectCostCenterBase { }